import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import instance from "../instance"; // Your Axios instance

export const useFetchSurveyQuestion=(filters)=>{
    const fetchSurvey= async()=>{
        const {data}= await instance.get(`/api/shopper/surveys-question?surveyTypeId=${filters?.surveyId}&projectId=${filters?.projectId}`)
   
   return data
 }
const query = useQuery({
    queryFn:fetchSurvey,
    queryKey:["fetch surveys"]
})
return query
}


export const useAnswerSurvey=()=>{
    const mutation= useMutation({mutationFn:async(payload)=>{
        const {data}= await instance.post(`/api/shopper/submit-survey`,payload)
        return data
    }})
    return mutation
}
export const useSubmitCriticalIssues=()=>{
    const mutation= useMutation({mutationFn:async(payload)=>{
        const {data}= await instance.post(`/api/shopper/submit-critical-issue`,payload)
        return data
    }})
    return mutation
}